import styled from 'styled-components';

export const ValueTagRemoveButton = styled.button`
    align-items: center;
    background: transparent;
    border: none;
    color: inherit;
    cursor: pointer;
    display: inline-flex;
    flex: none;
    height: 12px;
    justify-content: center;
    margin: 0;
    padding: 0;
    width: 12px;
`;
